export const LIST_ERROR = 'LIST_ERROR'
export const LIST_IS_LOADING = 'LIST_IS_LOADING'
export const LIST_FETCH_SUCCESS = 'LIST_FETCH_SUCCESS'
export const ITEM_FETCH_SUCCESS = 'ITEM_FETCH_SUCCESS'
export const ITEM_ERROR = 'ITEM_ERROR'
export const ITEM_IS_LOADING = 'ITEM_IS_LOADING'
export const FILL_FILTER = 'FILL_FILTER'

export const FILTER_ARGS = 'FILTER_ARGS'
export const FILTER_CATEGORIES_MULTIPLE_KEYWORDS =
    'FILTER_CATEGORIES_MULTIPLE_KEYWORDS'
export const FILTER_CATEGORIES_ONE_KEYWORD = 'FILTER_CATEGORIES_ONE_KEYWORD'
export const FILTER_SIZE = 'FILTER_SIZE'
export const FILTER_PRICE_RANGE = 'FILTER_PRICE_RANGE'
export const RESET_KEYWORDS = 'RESET_KEYWORDS'

export const CATEGORIES_PRODUCTS = 'CATEGORIES_PRODUCTS'

export const ADD_TO_CART = 'ADD_TO_CART'
export const DELETE_FROM_CART = 'DELETE_FROM_CART'
export const DELETE_ALL_FROM_CART = 'DELETE_ALL_FROM_CART'
export const CLEAR_CART = 'CLEAR_CART'

export const USER_ADDRESS = 'USER_ADDRESS'
export const LOGIN_USER = 'LOGIN_USER'
export const LOGOUT_USER = 'LOGOUT_USER'
export const SIGNUP_USER = 'SIGNUP_USER'
export const AUTH_USER = 'AUTH_USER'

export const UNAUTH_USER = 'unauth_user'
export const AUTH_ERROR = 'auth_error'
export const FETCH_FEATURE = 'fetch_feature'
